// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__BcifH","open":"style_open__4IvAM","list":"style_list__H38fM","label":"style_label__EWuk_","icon":"style_icon__cuQFr"};